import { Components, PaginationItem, Splide } from '@splidejs/splide'
import { css } from 'styled-components'

export const paginateVideoExtensionCSS = css`
  .splide__pagination {
    .splide__pagination__page {
      width: 9px;
      height: 9px;
      display: flex;
      align-items: center;

      &.video {
        width: 14px;
        height: 14px;
      }

      &.is-active svg path {
        color: rgba(255,255,255,0.8);
      }
    }
  }
`

// Purpose of this extention is to add play icon in the dots
export const PaginateVideoExtension = (splide: Splide, components: Components) => {
  const updateItems = ({ items }) => items.forEach((item: PaginationItem) => {
    const slide = components.Slides.getAt(item.page)?.slide
    if (slide) {
      const video = slide.getElementsByTagName('iframe')?.length > 0
      if (video) {
        item.button.classList.add('video')
        // eslint-disable-next-line no-param-reassign
        item.button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" width="12" height="12" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><path fill="currentColor" d="M8 5.14v14l11-7l-11-7Z"></path></svg>'
      }
    }
  })

  const mount = () => {
    updateItems({ items: splide.Components.Pagination.items })
    splide.on('pagination:mounted', updateItems)
  }

  const destroy = () => {
    splide.off('pagination:mounted')
  }

  return {
    destroy,
    mount,
  }
}
